import { FC } from 'react'
import styled, { css } from 'styled-components'
import { Button } from './Button'
import { ReloadIcon } from './icons/ReloadIcon'

type HeaderProps = {
  onClickReloadButton: () => void
}
export const Header: FC<HeaderProps> = (props) => {
  const { onClickReloadButton } = props

  return (
    <StyledHeader>
      <StyledFlex>
        <StyledLogo src="/proteger_logo.svg" alt="" />
      </StyledFlex>
      <Button onClick={onClickReloadButton} buttonType="icon">
        <ReloadIcon />
      </Button>
    </StyledHeader>
  )
}

const flex = css`
  display: flex;
  align-items: center;
`
const StyledHeader = styled.header`
  padding: 10px 20px;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 0 3px #cecece;
  z-index: 1;
  ${flex};
`
const StyledFlex = styled.div`
  ${flex}
`
const StyledLogo = styled.img`
  width: 140px;
  height: auto;
  margin-left: 20px;

  @media (max-width: 767px) {
    width: 35vw;
  }
`
